import { Any } from '@@react-spring/web/types';
import React from 'react';
import { Flex } from 'antd';
import FixedImpulseSpinner from './FixedSpinner';

function Loader(props: Any) {
	return (
		<Flex
			style={{ minHeight: '300px', ...(props.style || {}) }}
			align="center"
			justify="center"
			className="Loader w-100"
		>
			<FixedImpulseSpinner
				size={props.size || 60}
				frontColor={props.color || '#2EA0DF'}
			/>
		</Flex>
	);
}

export default Loader;
